export default __webpack_public_path__ + "static/media/mariog9.4c8886e4.jpg";